import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Products\ProductOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductOptionsController.php:45
* @route '/api/products/{configurableProduct}/{sku}/options'
*/
const ProductOptionsController = (args: { configurableProduct: string | number | { group_identifier: string | number }, sku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, sku: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProductOptionsController.url(args, options),
    method: 'get',
})

ProductOptionsController.definition = {
    methods: ["get","head"],
    url: '/api/products/{configurableProduct}/{sku}/options',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Products\ProductOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductOptionsController.php:45
* @route '/api/products/{configurableProduct}/{sku}/options'
*/
ProductOptionsController.url = (args: { configurableProduct: string | number | { group_identifier: string | number }, sku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, sku: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            configurableProduct: args[0],
            sku: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        configurableProduct: typeof args.configurableProduct === 'object'
        ? args.configurableProduct.group_identifier
        : args.configurableProduct,
        sku: args.sku,
    }

    return ProductOptionsController.definition.url
            .replace('{configurableProduct}', parsedArgs.configurableProduct.toString())
            .replace('{sku}', parsedArgs.sku.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Products\ProductOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductOptionsController.php:45
* @route '/api/products/{configurableProduct}/{sku}/options'
*/
ProductOptionsController.get = (args: { configurableProduct: string | number | { group_identifier: string | number }, sku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, sku: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProductOptionsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductOptionsController.php:45
* @route '/api/products/{configurableProduct}/{sku}/options'
*/
ProductOptionsController.head = (args: { configurableProduct: string | number | { group_identifier: string | number }, sku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, sku: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ProductOptionsController.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductOptionsController.php:45
* @route '/api/products/{configurableProduct}/{sku}/options'
*/
const ProductOptionsControllerForm = (args: { configurableProduct: string | number | { group_identifier: string | number }, sku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, sku: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductOptionsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductOptionsController.php:45
* @route '/api/products/{configurableProduct}/{sku}/options'
*/
ProductOptionsControllerForm.get = (args: { configurableProduct: string | number | { group_identifier: string | number }, sku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, sku: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductOptionsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductOptionsController::__invoke
* @see Http/Controllers/Api/Products/ProductOptionsController.php:45
* @route '/api/products/{configurableProduct}/{sku}/options'
*/
ProductOptionsControllerForm.head = (args: { configurableProduct: string | number | { group_identifier: string | number }, sku: string | number } | [configurableProduct: string | number | { group_identifier: string | number }, sku: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductOptionsController.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

ProductOptionsController.form = ProductOptionsControllerForm

export default ProductOptionsController